import { Region } from './DomainUtils';
import { DOMAIN_INFO } from 'src/utils/WindowUtils';

export const zipCodeFormatters: { [region: string]: (zipCode: string, shippingCountry?: string) => string } = {
  [Region.NA]: (zipCode) => {
    // Check if it's a Canadian postal code format (A1A 1A1 or A1A1A1)
    if (/^[A-Za-z]\d[A-Za-z](\s?\d[A-Za-z]\d)?$/.test(zipCode)) {
      // For Canadian postal codes, return first 3 characters + space + next 2 characters (A1A 1A)
      if (zipCode.includes(' ')) {
        // Already has space, return first 6 characters (A1A 1A)
        return zipCode.substring(0, 6);
      } else {
        // No space, add space after first 3 characters and return first 6
        const formatted = zipCode.substring(0, 3) + ' ' + zipCode.substring(3, 5);
        return formatted;
      }
    }
    // For US and other NA countries, take the first 5 digits
    return zipCode.substring(0, 5);
  },
  [Region.EU]: (zipCode, shippingCountry) => {
    // Special handling for Netherlands (NL) postal codes
    //TODO Should refactor this file
    if (shippingCountry && shippingCountry.toLowerCase() === 'nl') {
      // For Dutch postal codes (e.g., "2405 VB"), return only the numeric part
      return zipCode.replace(/\D/g, '').substring(0, 4);
    }
    // Existing UK handling
    const parts = zipCode.split(' ');
    if (parts.length === 2) {
      return `${parts[0]} ${parts[1][0]}`;
    }
    // If the format is unexpected, return the first 5 characters
    return zipCode.substring(0, 5);
  },
  [Region.FE]: (zipCode) => {
    // Check if the zipcode matches the pattern XXX-XXXX
    if (/^\d{3}-\d{4}$/.test(zipCode)) {
      // If it matches, return the first 7 characters (XXX-XXX)
      return zipCode.substring(0, 7);
    }
    // If it doesn't match the pattern, return it as is which is for AU
    return zipCode;
  },
};

export function trimZipCode(zipCode: string, shippingCountry?: string): string {
  const region = DOMAIN_INFO?.region || Region.NA;
  const formatZipCode = zipCodeFormatters[region] || zipCodeFormatters[Region.NA];
  return formatZipCode(zipCode, shippingCountry);
}

export function getTrimZipCode(): (zipCode: string, shippingCountry?: string) => string {
  return (zipCode: string, shippingCountry?: string) => trimZipCode(zipCode, shippingCountry);
}
